<template>

    <div class="modal" tabindex="-1" id="restockModal">
        <div class="modal-dialog modal-dialog-centered modal-restock">
            <div class="modal-content">
                <div class="modal-body">
                    <button type="button" class="close" data-dismiss="modal" :aria-label="lang('all.close')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <div>
                        <h3>
                            <i class="mdi mdi-information-outline"></i>
                            {{ lang('all.verwachte_toeleveringen') }}
                        </h3>
                        <div class="loader" v-if="error">
                            <div style="display:block;font-size:3em;" class="pb-3">
                                <i class="mdi mdi-alert"></i>
                            </div>
                            <div v-if="throttled">
                                {{ lang('all.je_bent_te_snel_heel_even_wachten_dan_kun_je_de_ge') }}
                            </div>
                            <div v-else>
                                {{ lang('all.er_is_een_fout_opgetreden_probeer_het_later_opnieu') }}
                            </div>
                        </div>
                        <div class="loader" v-else-if="!loaded">
                            <div class="spinner-border" role="status">
                                <span class="sr-only">{{ lang('all.laden') }}</span>
                            </div>
                        </div>
                        <table class="table" v-else>
                            <thead>
                                <tr>
                                    <th>{{ lang('all.datum') }}</th>
                                    <th>{{ lang('all.oplage') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="restock.length === 0">
                                    <td colspan="2">{{ lang('all.er_is_momenteel_geen_informatie_over_toekomstige_t') }}</td>
                                </tr>
                                <tr v-for="entry in restock">
                                    <td>{{ formatDate(entry.date) }}</td>
                                    <td>{{ entry.quantity }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import axios from "axios";
import moment from "moment";

export default {

    data() {
        return {
            error:false,
            loaded:false,
            restock:[],
            sku:null,
            throttled:false,
        }
    },

    methods: {

        getRestock() {
            this.loaded = false;
            this.restock = [];

            axios.get(this.route('api.v1.restock.show', {sku: this.sku}))
                .then(resp => {
                    this.restock = resp.data.data;
                    this.loaded = true;
                })
                .catch(err => {
                    this.error = true;
                    if (err.response.status === 429) {
                        this.throttled = true;
                    }
                })
        },

        formatDate(date) {
            return moment(date).format('D MMMM YYYY');
        },

        reset() {
            this.error = false;
            this.loaded = false;
            this.throttled = false;
        },

        showRestock(sku) {
            this.reset();
            this.sku = sku;
            jQuery('#restockModal').modal('show');
            this.getRestock();
        },

    },

    name:'ProductsRestock',

}

</script>
